import { render, staticRenderFns } from "./app-super-admin-marker.vue?vue&type=template&id=1041e7ae"
import script from "./app-super-admin-marker.vue?vue&type=script&lang=ts"
export * from "./app-super-admin-marker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1041e7ae')) {
      api.createRecord('1041e7ae', component.options)
    } else {
      api.reload('1041e7ae', component.options)
    }
    module.hot.accept("./app-super-admin-marker.vue?vue&type=template&id=1041e7ae", function () {
      api.rerender('1041e7ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-super-admin-marker/app-super-admin-marker.vue"
export default component.exports